module.exports = __webpack_public_path__ + "components/rewards/hike-and-ride/static/icon-9174115ad4a0b3706049d6995cf18e48.png";